import React from 'react'
import { sortBy, groupBy } from 'lodash-es'
import EventCell from './event-cell'
import TimeCell from './time-cell'

const Events = ({ events }) => {
  let eventsByDate = groupBy(events, entry => {
    return new Date(entry.time)
  })

  let sortedEvents = sortBy(
    Object.keys(eventsByDate).map(date => ({
      date,
      order: new Date(date).getTime(),
      events: eventsByDate[date]
    })),
    'order'
  )

  return sortedEvents.map(({ date, events }) => {
    let dateTime = new Date(date)

    return (
      <dl
        key={`event-${date}`}
        className="m-0"
      >
        <TimeCell time={dateTime} />

        {events.map(event => (
          <EventCell
            key={`${event.time}-${event.title}`}
            event={event}
          />
        ))}
      </dl>
    )
  })
}

export default Events
